
import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL;

// Create an instance of axios with default settings
const axiosInstance = axios.create({
  baseURL: BASE_URL,
});

// Add a request interceptor to include the token in the headers
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("userToken");

    if (token) {
      config.headers["x-access-token"] = token; // Set the token in the header
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);


// Get User Communities Values API function
export const getUserCommunities = async (payload) => {
  try {
    const response = await axiosInstance.post("/getUserCommunities", payload);
    return response.data;
  } catch (error) {
    console.error("getAllCommunities API Error:", error);
    throw error;
  }
};
export const getCommunityTopics = async (payload) => {
  try {
    const response = await axiosInstance.post("/getCommunityTopics", payload);
    return response.data;
  } catch (error) {
    console.error("getCommunityTopics API Error:", error);
    throw error;
  }
};

export const savePost = async (payload) => {
  try {
    const response = await axiosInstance.post("/savePost", payload);
    return response.data;
  } catch (error) {
    console.error("SavepOst API Error:", error);
    throw error;
  }
};

export const listCommunityPosts = async (payload) => {
  try {
    const response = await axiosInstance.post("/listCommunityPosts", payload);
    return response.data;
  } catch (error) {
    console.error("SavepOst API Error:", error);
    throw error;
  }
};

export const savePostComment = async (payload) => {
  try {
    const response = await axiosInstance.post("/savePostComment", payload);
    return response.data;
  } catch (error) {
    console.error("savePostComment API Error:", error);
    throw error;
  }
};

export const savePostShortlist = async (payload) => {
  try {
    const response = await axiosInstance.post("/savePostShortlist", payload);
    return response.data;
  } catch (error) {
    console.error("savePostShortlist API Error:", error);
    throw error;
  }
};

export const savePostLike = async (payload) => {
  try {
    const response = await axiosInstance.post("/savePostLike", payload);
    return response.data;
  } catch (error) {
    console.error("savePostLike API Error:", error);
    throw error;
  }
};

export const deletePost = async (payload) => {
  try {
    const response = await axiosInstance.post("/deletePost", payload);
    return response.data;
  } catch (error) {
    console.error("deletePost API Error:", error);
    throw error;
  }
};

export const saveReportPost = async (payload) => {
  try {
    const response = await axiosInstance.post("/saveReportPost", payload);
    return response.data;
  } catch (error) {
    console.error("saveReportPost API Error:", error);
    throw error;
  }
};


export const getTrendingTopics = async (payload) => {
  try {
    const response = await axiosInstance.post("/getTrendingTopics", payload);
    return response.data;
  } catch (error) {
    console.error("saveReportPost API Error:", error);
    throw error;
  }
};

export const saveFavouriteMember = async (payload) => {
  try {
    const response = await axiosInstance.post("/saveFavouriteMember", payload);
    return response.data;
  } catch (error) {
    console.error("saveReportPost API Error:", error);
    throw error;
  }
};
export const removePostLike = async (payload) => {
  try {
    const response = await axiosInstance.post("/removePostLike", payload);
    return response.data;
  } catch (error) {
    console.error("removePostLike API Error:", error);
    throw error;
  }
};

export const editPost = async (payload) => {
  try {
    const response = await axiosInstance.post("/editPost", payload);
    return response.data;
  } catch (error) {
    console.error("editPost API Error:", error);
    throw error;
  }

};
export const getAllComments = async (payload) => {
  try {
    const response = await axiosInstance.post("/getAllComments", payload);
    return response.data;
  } catch (error) {
    console.error("getAllComments API Error:", error);
    throw error;
  }
};

export const getAnnouncement = async (payload) => {
  try {
    const response = await axiosInstance.post("/getAnnouncement", payload);
    return response.data;
  } catch (error) {
    console.error("getAnnouncement API Error:", error);
    throw error;
  }
};

export const closeAnnouncement = async (payload) => {
  try {
    const response = await axiosInstance.post("/closeAnnouncement", payload);
    return response.data;
  } catch (error) {
    console.error("closeAnnouncement API Error:", error);
    throw error;
  }
};

export const checkTopicExist = async (payload) => {
  try {
    const response = await axiosInstance.post("/checkTopicExist", payload);
    return response.data;
  } catch (error) {
    console.error("checkTopicExist API Error:", error);
    throw error;
  }
};

export const peopleLikeMePosts = async (payload) => {
  try {
    const response = await axiosInstance.post("/peopleLikeMePosts", payload);
    return response.data;
  } catch (error) {
    console.error("peopleLikeMePosts API Error:", error);
    throw error;
  }
};

export const searchByPost = async (payload) => {
  try {
    const response = await axiosInstance.post("/searchByPost", payload);
    return response.data;
  } catch (error) {
    console.error("searchByPost API Error:", error);
    throw error;
  }
};






